<template>
	<div
		ref="imageWrapper"
		class="imgWrapper d-flex"
		:style="{ height: imageHeight }"
	>
		<img
			v-if="imageSrc"
			:src="imageSrc"
			alt="image"
			class="no-flex full-width"
			:class="{
				'is-blurred': !bypassPreFetch && !imageSrc
			}"
		/>
		<v-progress-circular
			v-else
			indeterminate
			:size="isThumb ? 20 : 50"
			color="blue-grey lighten-3"
		></v-progress-circular>
	</div>
</template>

<script>
import * as utils from "@/utils.js"

export default {
	name: "AnalyticsElImg",
	data() {
		return {
			imageWidth: 550
		}
	},
	props: [
		"SM",
		"src",
		"post",
		"isFullView",
		"bypassPreFetch",
		"preFetchImages",
		"isThumb"
	],
	mounted() {
		this.imageWidth = this.parentWrapper().clientWidth
	},
	updated() {
		this.$nextTick(() => {
			const parentWrapper = this.parentWrapper()
			if (parentWrapper) {
				this.imageWidth = parentWrapper.clientWidth
			}
		})
	},
	computed: {
		imageSrc() {
			return utils.getImageSrc(
				this.src,
				this.bypassPreFetch,
				this.preFetchImages
			)
		},
		imageHeight() {
			return this.isFullView ? this.getGraphicHeight : "200px"
		},
		getGraphicHeight() {
			if (this.SM) {
				return "auto"
			}

			const post = this.post
			if (post.width && post.height) {
				return (post.height.N / post.width.N) * this.imageWidth + "px"
			}
			return "auto"
		}
	},
	methods: {
		parentWrapper() {
			return this.$refs.imageWrapper
		}
		// getImageMaxWidth() {
		// 	const post = this.post
		// 	let req_width = parseInt(post.width ? post.width.N : 400, 10)
		// 	if (post.width && post.height && parseInt(post.height.N, 10) > 400) {
		// 		req_width = (req_width * 400) / parseInt(post.height.N, 10)
		// 	}
		// 	return Math.max(200, req_width) + "px"
		// }
	}
}
</script>

<style lang="scss" scoped>
.imgWrapper {
	overflow: hidden;
	text-align: center;
	justify-content: center;
	align-items: center;
	background-color: #f9f9f9;
	background: linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%);
	min-height: 100px;
	img {
		flex: none;
	}
}
.is-blurred {
	filter: blur(4px);
}
</style>
